<template>
    <section id="car-models" ref="carSection">
        <transition name="fade">
            <div class="row" v-if="cars.length">
                <div class="col-sm-12 text-center">
                    <h2>eine typfrage.</h2><small>Wählen Sie jetzt bitte Ihr Modell.</small>
                </div>
            </div>
        </transition>
        <transition name="fade">
            <div class="row cars-row" v-if="cars.length">
                <div class="row">
                    <template v-for="car in cars">
                        <car-model :car="car"></car-model>
                    </template>
                </div>
            </div>
        </transition>
        <div class="row cars-row" v-if="bottomButtons">
            <div class="row">
                <div class="col-sm-3"><button class="btn btn-dark" @click="showStoredCars">Gespeicherte</button></div>
                <div class="col-sm-3">
                    <button class="btn btn-dark" data-toggle="modal" href="#saveCar" data-backdrop="true" v-if="logedIn">Speichern</button>
                    <button class="btn btn-dark" data-toggle="modal" @click="login" data-backdrop="true" v-else>Speichern</button>
                </div>
                <div class="col-sm-6"><button class="btn active" @click="showAll">Alle Teile anzeigen</button></div>
            </div>
        </div>
        <div class="modal fade" id="saveCar" role="dialog">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal">
                            <i class="fa fa-times"></i>
                        </button>
                        <h4>auto speichern</h4>
                    </div>
                    <div class="modal-body">
                        <form>
                            <div :hidden="hideSuccess">
                                Das Auto wurde gespeichert.
                            </div>
                            <div :hidden="hideFormFields">
                                <div :class="formGroupClass('error')">
                                    <div class="form-group">
                                        <div class="help-block" v-if="form.errors.has('error')">
                                            <strong>{{ form.errors.get('error') }}</strong>
                                        </div>
                                    </div>
                                </div>
                                <div :class="formGroupClass('tyre_equipment')">
                                    <div class="form-group">
                                        <input class="form-control" id="tyre_equipment" type="text" name="tyre_equipment" placeholder="Auto Name" v-model="form.tyre_equipment" required="required"/>
                                        <div class="help-block" v-if="form.errors.has('tyre_equipment')">
                                            <strong>{{ form.errors.get('tyre_equipment') }}</strong>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <button class="btn active loginBTN" type="button" @click="onClick" :disabled="loading">
                                        <i class="fa fa-spinner fa-spin" v-if="loading"></i>
                                        <slot>SPEICHERN</slot>
                                    </button>
                                </div>
                            </div>
                            <input id="brand" type="hidden" name="brand" v-model="form.brand" />
                            <input id="year" type="hidden" name="year" v-model="form.year" />
                            <input id="type" type="hidden" name="type" v-model="form.type" />
                            <input id="carseo" type="hidden" name="carseo" v-model="form.carseo" />
                        </form>
                    </div>
                    <div class="modal-footer"></div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {

        data() {
            return {
                cars: [],
                bottomButtons: false,
                carseo: null,
                form: new Form({
                    tyre_equipment: null,
                    brand: null,
                    year: null,
                    type: null,
                    carseo: null
                }),
                loading: false,
                hideFormFields: false,
                hideSuccess: true,
                logedIn: null
            }
        },

        created() {
            this.fetchUser();

            App.event.listen('car.brand.loaded', (cars) => {
                this.cars = cars;
            });

            App.event.listen('car.brand.selected', (selection) => {

                this.cars = [];
                this.form.brand = selection;
                this.form.carseo = null;
                this.carseo = null;
                this.form.year = null;
                this.form.type = null;
                
                let target = $(this.$refs.carSection);
                $('html, body').stop().animate({
                    scrollTop: target.offset().top
                }, 1000);

            });

            App.event.listen('car.selection.loaded', selection => {
                if (selection.cars) {
                    let key = Object.keys(selection.cars).pop();
                    this.form.brand = key;
                    this.form.carseo = null;
                    this.carseo = null;
                    this.form.year = null;
                    this.form.type = null;
                    this.cars = selection.cars[key];
                    setTimeout(() => {
                        App.event.fire('car.selection.ready.cars', selection);
                    }, 1000);
                }
            });

            App.event.listen('car.selection.ready.cars', selection => {
            
                if (selection.categories) {
                    this.bottomButtons = true;
                    let year = Object.keys(selection.types).pop();
                    let type = Object.keys(selection.categories).pop();
                    let seo  = '';

                    _.find(selection.types[year], (types) => {
                        let typ = _.find(types.children, (children) => {
                            let car = _.find(children.grandchildren, (grandchild) => {
                                seo =  grandchild.id == type ? grandchild.seo : seo;
                            });
                        });
                    });

                    this.form.carseo = seo;
                    this.carseo = seo;
                    this.form.year = year;
                    this.form.type = type;
                }

            });

            App.event.listen('car.categories.loaded', () => {
                this.bottomButtons = true; 
            });

            App.event.listen('car.year.selected', ({year}) =>  {
                this.form.year = year;
                this.form.carseo = null;
                this.carseo = null;
                this.form.type = null;
            });
            App.event.listen('car.type.selected', ({type, carseo}) => { 
                this.form.type = type;
                this.form.carseo = carseo;
                this.carseo = carseo;
            });

            App.event.listen('saveCar.send', () => {
                this.form.post('/profile/cars/save-car').then(response => {
                    this.hideFormFields = true;
                    this.hideSuccess = false;
                }).catch(errors => {
                    this.loading = false;
                    App.event.fire('saveCar.failed', errors);
                });
            });
        },

        methods: {
            fetchUser() {
                new Form().get('/api/me')
                .then(user => {
                    this.logedIn = true;
                }).catch(error => {
                    this.logedIn = false;
                });
            },

            showAll() {
                window.location = App.url+'/category/' + this.carseo;
            },

            showStoredCars() {
                window.location = App.url+'/profile/cars';
            },

            login() {
                window.location = App.url+'/login';
            },

            formGroupClass(name) {
                return this.form.errors.has(name) ? 'form-group has-error' : 'form-group';
            },

            onClick() {
                this.loading = true;
                App.event.fire('saveCar.send');
            }
        },
        
    }
</script>